import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import * as notifications from '@app/utils/notifications'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { DueDiligenceItemEditModal } from '../components/DueDiligenceItemEditModal'
import {
  actionCreators,
  IDueDiligenceItemEditState,
  selectError,
  selectIsOpen,
  selectIsSaving,
  selectItem,
} from '../modules/dueDiligenceItemEdit'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IDueDiligenceItemEditState & ICurrentUserState
  >({
    error: selectError(),
    isOpen: selectIsOpen(),
    isSaving: selectIsSaving(),
    item: selectItem(),
    user: selectCurrentUser(),
  }),
  {
    ...actionCreators,
    ...notifications,
  },
)(DueDiligenceItemEditModal)
